import { BUTTON_VARIANTS, Button, BUTTON_SIZES } from 'ui/button';
import { MODAL_SIZES, ModalFooter, ModalHeader, MODAL_VARIANTS } from 'ui/modal';
import {
  TestMsgModals,
  useSendTestMsgContext,
} from 'modules/templateEditor/context/SendTestMsgContext';
import { useSelector } from 'react-redux';
import { selectEmail } from 'core/userContext';
import { useDisplayTestMessageStatus } from 'modules/templateEditor/hooks/useDisplayTestMessageStatus';
import { Body2 } from 'ui/theme';
import { displayContent } from 'modules/templateEditor/common';
import { StyledModal, StyledModalBody } from '../SendTestMsgModals.styled';

export const DISPLAY_TEST_MESSAGE_MODAL_TEST_ID = 'display-test-message-modal';

export const DisplayTestMsgToYourselfModal = () => {
  const { onDisplayTestToSelf, setOpenTestMsgModal } = useSendTestMsgContext();
  const { isDisplayingForSelf } = useDisplayTestMessageStatus();
  const userEmail = useSelector(selectEmail);

  const handleCloseModal = () => {
    setOpenTestMsgModal(TestMsgModals.None);
  };

  const handleSubmit = (removing = false) => {
    onDisplayTestToSelf(removing);
    handleCloseModal();
  };

  return (
    <StyledModal
      id="displayTestMsgToYourselfModal"
      isModalOpen={true}
      onClose={handleCloseModal}
      data-test={DISPLAY_TEST_MESSAGE_MODAL_TEST_ID}
      size={MODAL_SIZES.MEDIUM}
      variant={MODAL_VARIANTS.DEFAULT}
    >
      <ModalHeader autoFocus={false}>{displayContent.strDisplayTestToSelfTitle}</ModalHeader>
      <StyledModalBody>
        <Body2>
          {displayContent.strDisplayTestToSelfTitle} at {userEmail}
        </Body2>
        {/* Hiding until proof system for eligibility is available with end dates */}
        {/* <StyledFormField labelText="Display stop date">
          <DatePickerWithCollapsibleCalendar date={moment(nextDay)} />
          <TypeaheadTimePicker time={moment(nextDay).format('hh:mm A') as TimeIn12HourClock} />
        </StyledFormField> */}
      </StyledModalBody>

      <ModalFooter hasCancel={false}>
        <Button
          variant={BUTTON_VARIANTS.GHOST}
          onClick={handleCloseModal}
          size={BUTTON_SIZES.LARGE}
        >
          {displayContent.btnCancel}
        </Button>
        {isDisplayingForSelf ? (
          <Button
            data-test="displayTestMsgStopBtn"
            onClick={() => handleSubmit(true)}
            variant={BUTTON_VARIANTS.SECONDARYDESTRUCTIVE}
            size={BUTTON_SIZES.LARGE}
          >
            {displayContent.btnClearTestMessage}
          </Button>
        ) : (
          <Button onClick={() => handleSubmit()} size={BUTTON_SIZES.LARGE}>
            {displayContent.btnStartTestMessage}
          </Button>
        )}
      </ModalFooter>
    </StyledModal>
  );
};
